import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { useAgentProfileInfo } from "@/react/hooks/agent_profile/useAgentProfileInfo";
import { PROFILE_PAGES } from "@circle-react/helpers/memberHelper";
import { Modal } from "@circle-react-shared/uikit/ModalV2";
import { ModalCloseButton } from "@circle-react-shared/uikit/ModalV2/ModalCloseButton";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { AgentProfile } from "./AgentProfile";

const pageParams = {
  page_name: PROFILE_PAGES.PROFILE_VIEW,
};

export interface AgentProfileModalProps {
  agentId: number;
  params?: {
    shouldOpenInNewTab?: boolean;
  };
}

export const AgentProfileModal = ({ agentId }: AgentProfileModalProps) => {
  const modal = useModal();
  const {
    getAgentProfileInfoQuery: { data: agent, isLoading },
  } = useAgentProfileInfo({
    agentId,
    params: pageParams,
  });

  const onClose = () => {
    modal.remove();
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={onClose}
      contentPortalId="post-modal-portal"
    >
      <Modal.Overlay />
      <Modal.Content size="2xl" className="max-w-screen-xl">
        <div className="border-primary text-dark flex justify-between border-b !px-9 !py-4">
          <Typography.TitleSm weight="semibold">
            {t("profile")}
          </Typography.TitleSm>
          <ModalCloseButton onClick={onClose} />
        </div>
        <Modal.Body className="!md:px-0 !md:pt-0 !md:overflow-hidden block grid-cols-12 !p-0 md:grid md:grid-flow-row-dense">
          <AgentProfile
            agent={agent}
            isLoading={isLoading}
            onClose={() => modal.remove()}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
